import React from 'react';

import { observer } from 'mobx-react';

import withDisplayName from 'bz-utilities/hoc/display-name';
import useComputed from 'bz-utilities/hooks/computed';

import { cache } from 'tm3-core/cache';

const ShellPrivacy = observer(
  withDisplayName((props) => {
    const url = useComputed(() => {
      if (cache.isEClinic) {
        return 'https://e-clinic.co.uk/privacy-policy/';
      } else if (cache.isGDS) {
        return 'https://www.gds.co.uk/privacy';
      } else if (cache.isPPM) {
        return 'https://e-clinic.co.uk/privacy-policy/';
      }

      return 'https://www.tm3app.com/information/policy';
    }, []);

    return (
      <a style={{ marginLeft: 15, color: '#999' }} href={url} target="_blank">
        Privacy Policy
      </a>
    );
  }, 'ShellPrivacy')
);

export default ShellPrivacy;
